import { flow } from 'fp-ts/function';
import { compose, get, getOr, keyBy } from 'lodash/fp';
import { SearchType } from '@mews-commander/enums';
import { getStringProp, keyById } from '@mews/fp';
import { createAction, createReducer } from '@mews/framework';
import { Company } from '@mews-commander/data-access';
import { createEntitySelector } from '@mews-commander/utils';
import prefix from '../prefix';
import moduleSelector from '../selector';
import { mapSearchResults } from './utils';

export const NAME = 'travelAgencies';

// duplicated from modules\modules\src\modules\search\actions\actionTypes.ts
// reason: to isolate entities module
const SEARCH_PREFIX = 'search';
const SEARCH_SUCCEEDED = `${SEARCH_PREFIX}/SEARCH_SUCCEEDED`;
const SEARCH_MORE_SUCCEEDED = `${SEARCH_PREFIX}/SEARCH_MORE_SUCCEEDED`;

const TRAVEL_AGENCIES_LOADED = prefix('TRAVEL_AGENCIES_LOADED');
export const setTravelAgencies = (travelAgencies: Array<Company>) =>
    createAction(TRAVEL_AGENCIES_LOADED, { entities: travelAgencies });

const mapTravelAgencySearch = compose(keyBy('id'), mapSearchResults(SearchType.TravelAgency));

export const travelAgenciesReducer = createReducer(
    {},
    {
        // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
        [SEARCH_SUCCEEDED]: (state, payload) => ({
            ...state,
            ...mapTravelAgencySearch(payload),
        }),
        // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
        [SEARCH_MORE_SUCCEEDED]: (state, payload) => ({
            ...state,
            ...mapTravelAgencySearch(payload),
        }),
        // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
        [TRAVEL_AGENCIES_LOADED]: (state, { entities }: $TSFixMe) => ({
            ...state,
            ...keyById(entities),
        }),
    }
);

export const getTravelAgencies = compose(getOr({}, NAME), moduleSelector);

export const getTravelAgency = createEntitySelector(getTravelAgencies, getStringProp('travelAgencyId'));
export const getTravelAgencyName = flow(getTravelAgency, get('name'));
